// API Configuration for Admin App
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
const API_BASE_PATH = process.env.REACT_APP_API_BASE_PATH || '';

export const joinUrl = (baseUrl, basePath) => {
  const b = String(baseUrl || '').replace(/\/+$/, '');
  let p = String(basePath || '');
  if (p && !p.startsWith('/')) p = `/${p}`;
  return `${b}${p}`;
};

/** Base URL for JSON API (e.g. https://host/mforesor/api). Uploads live at `${API_ROOT}/uploads/...`. */
export const API_ROOT = joinUrl(API_BASE_URL, API_BASE_PATH);

export const API_ENDPOINTS = {
  BOOKINGS: `${API_ROOT}/bookings`,
  UPDATE_STATUS: (reference) => `${API_ROOT}/bookings/${reference}/status`,
  UPDATE_PAYMENT_STATUS: (reference) => `${API_ROOT}/bookings/${reference}/payment-status`,
  PACKAGES: `${API_ROOT}/packages`,
  PACKAGE_BY_ID: (id) => `${API_ROOT}/packages/${id}`,
  PACKAGE_BOOKINGS: (id) => `${API_ROOT}/packages/${id}/bookings`,
};

export default API_BASE_URL;
